import { AuthConsumer } from "./authProvider";

const LogoutCallback = () => (
    <AuthConsumer>
    {({ signoutRedirectCallback }) => {
    signoutRedirectCallback();
    return <span>loading </span>;
}}
</AuthConsumer>
);

export default LogoutCallback;
